import "./index-section-title.css";

// export default function SectionTitle({
//   eyebrow,
//   title,
//   subtitle,
//   light = false,
// }) {
//   return (
//     <div
//       className={`ep-section-title ${light ? "ep-section-title--light" : ""}`}
//     >
//       {eyebrow && <span className="ep-section-title-eyebrow">{eyebrow}</span>}
//       <h2>{title}</h2>
//       {subtitle && <p>{subtitle}</p>}
//       <span className="ep-section-title-line" />
//     </div>
//   );
// }

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  align = "left",
}) {
  return (
    <div className={`section-title ${align}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
      <i />
    </div>
  );
}
